import * as React from "react";
import cx from "classnames";
import { HashLink as Link } from "react-router-hash-link";

export interface NavItemProps {
  to: string;
  children: string;
  active?: boolean;
}

const NavItem = ({ to, children, active }: NavItemProps) => (
  <li className={cx({ active })}>
    <Link className="nav-item" to={to} replace>
      {children}
    </Link>
  </li>
);

export default NavItem;



// WEBPACK FOOTER //
// ./src/layouts/Main/NavItem.tsx